var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85,
    height: 85.001,
    viewBox: "0 0 102 102.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_53405",
    "data-name": "Path 53405",
    d: "M397.686,372.735a51,51,0,1,0,51,51A51.058,51.058,0,0,0,397.686,372.735ZM427.713,455.2a55.654,55.654,0,0,0-6.692-3.283c-4.164-1.729-6.167-2.152-8.736-4.28-6.033-5-3.421-12.621-1.612-16.313a24.365,24.365,0,0,0,4.413-6.791c.229.653.506,1.042.806,1.042.778,0,1.408-2.562,1.408-5.723a20.733,20.733,0,0,0-.163-2.621,30.371,30.371,0,0,0,.324-4.191,20.873,20.873,0,1,0-39.549,0,30.049,30.049,0,0,0,.177,3,18.246,18.246,0,0,0-.365,3.812c0,3.161.63,5.723,1.408,5.723.37,0,.705-.594.957-1.549a24.558,24.558,0,0,0,4.61,7.3c1.809,3.691,4.422,11.314-1.611,16.313-2.569,2.128-4.574,2.55-8.736,4.28a55.554,55.554,0,0,0-6.692,3.283,43.524,43.524,0,1,1,60.054,0Z",
    transform: "translate(-346.685 -372.735)",
    fill: "#734bd1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileUser);
export default __webpack_public_path__ + "static/media/profile-user.c8ed23741e8b7e66230f672eda3e6540.svg";
export { ForwardRef as ReactComponent };